module.exports = __webpack_public_path__ + "img/article-limit-image.355184ce.png";